import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=556d8dbb&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('556d8dbb')) {
      api.createRecord('556d8dbb', component.options)
    } else {
      api.reload('556d8dbb', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=556d8dbb&", function () {
      api.rerender('556d8dbb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2uz8KARlUcON6/JS/offershelp.vue"
export default component.exports